import React from 'react';
import { Layout, Button, Tabs, Radio, Modal, Spin, Select, Tree, Dropdown, Icon, Menu, Tooltip } from 'antd';

import "./index.less";

export default class ListGrid extends React.Component {

    state = {
    };

    componentWillMount() {

    }

    componentWillUnmount() {

    }

    onClick(i) {
        if (this.props.onSelect)
            this.props.onSelect(i);
    }

    onDoubleClick(i) {
        if (this.props.onOpen)
            this.props.onOpen(i);
    }

    onScroll(e) {
        this.props.onScroll && this.props.onScroll(e);
    }

    render() {

        return (
            <div className={"layout-v list-grid " + (this.props.className || "")} style={this.props.style} onScroll={e => this.onScroll(e)} >
                {
                    this.props.children.map((c, i) => (
                        <Button
                            key={i}
                            onDoubleClick={e => this.onDoubleClick(i)}
                            onClick={e => this.onClick(i)}
                            className={'btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none grid-item '}>
                            <div className={"grid-item-div " + (this.props.selectedItems && this.props.selectedItems.indexOf(i) >= 0 ? "treenode-selected" : "")}>
                                {c}
                            </div>
                        </Button>
                    ))
                }
            </div>
        );
    }
}
